module.exports = __webpack_public_path__ + "img/industrial_vehicles-icon2.9d8963ec.png";